import { Link } from "react-router-dom";

export const INDOOR_SECURITY_CAMERAS = [
  {
    id: "eufy-IndoorCam-E30",
    imageUrl: "/images/products/eufy-indoorcam-e30.webp",
    title: "eufy Indoor Cam E30",
    stock: 3,
    price: 269,
    oldPrice: 269,
    upsell: ["SanDisk-Ultra-128GB", "eufy-HomeBase-S380"],
    description: [
      {
        key: { ka: "რეზოლუცია:", en: "Resolution:" },
        value: { ka: "4K", en: "4K" },
      },
      {
        key: { ka: "ხედვის არეალი:", en: "Field of View:" },
        value: { ka: "125°-360°", en: "125°-360°" },
      },
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "Wi-Fi", en: "Wi-Fi" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: { ka: "USB კაბელი", en: "USB cable" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "ჩაწერა:", en: "Recording:" },
        value: {
          ka: "კამერა ჩაიწერს უწყვეტად ან მხოლოდ მოძრაობის დაფიქსირებისას.",
          en: "The camera records continuously or only when motion is detected.",
        },
      },
      {
        key: { ka: "მონიტორინგი:", en: "Monitoring:" },
        value: {
          ka: "ნებისმიერ დროს, ნებისმიერი ადგილიდან ლაივში აპლიკაციით ნახე ყველა მნიშვნელოვანი მომენტი 4K ხარისხში.",
          en: "Watch all important moments live in 4K quality anytime, anywhere via the app.",
        },
      },
      {
        key: { ka: "მოძრაობის თრექინგი:", en: "Motion Tracking:" },
        value: {
          ka: "კამერას შეუძლია ადამიანისა და შინაური ცხოველის ავტომატური თრექინგი 360°-ით.",
          en: "The camera automatically tracks people and pets 360°.",
        },
      },
      {
        key: { ka: "ფერადი ღამის ხედვა:", en: "Color Night Vision:" },
        value: {
          ka: "ჩაშენებული განათება უზრუნველყოფს ფერად ღამის ხედვას სიბნელეშიც.",
          en: "The built-in spotlight enables color night vision even in the dark.",
        },
      },
      {
        key: { ka: "აუდიო კომუნიკაცია:", en: "Audio Communication:" },
        value: {
          ka: "დაელაპარაკე კამერასთან მყოფებს აპლიკაციით.",
          en: "Talk to people near the camera via the app.",
        },
      },
      {
        key: {
          ka: "ჭკვიანი სახლის ინტეგრაციები:",
          en: "Smart Home Integrations:",
        },
        value: {
          ka: "Apple HomeKit, Amazon Alexa, Google Assistant",
          en: "Apple HomeKit, Amazon Alexa, Google Assistant",
        },
      },
      {
        key: (
          <Link
            className="underline"
            to="https://www.eufy.com/privacy-commitment"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang="ka">კონფიდენციალური და დაშიფრული:</span>
            <span lang="en">Confidential and Encrypted:</span>
          </Link>
        ),
        value: {
          ka: "ჩანაწერები ინახება მხოლოდ შენს კამერაში და დაშიფრულია AES-128 ალგორითმით, ლაივ კავშირი კი დაცული და უსაფრთხოა.",
          en: "Recordings are stored only on your camera and encrypted with AES-128. Live connection is protected and secure.",
        },
      },
    ],
    video: "https://www.youtube.com/embed/dWMZ6-H5pYw",
    specs: [
      {
        key: { ka: "რეზოლუცია", en: "Resolution" },
        value: { ka: "4K (3840 x 2160)", en: "4K (3840 x 2160)" },
      },
      {
        key: {
          ka: "სტატიკური ფართო ხედვის არეალი",
          en: "Static Wide Field of View",
        },
        value: { ka: "125°", en: "125°" },
      },
      {
        key: { ka: "დინამიური ხედვის არეალი", en: "Dynamic Field of View" },
        value: {
          ka: (
            <>
              <p>360° ჰორიზონტალურად</p>
              <p>75° ვერტიკალურად</p>
            </>
          ),
          en: (
            <>
              <p>360° horizontally</p>
              <p>75° vertically</p>
            </>
          ),
        },
      },
      {
        key: { ka: "ღამის ხედვა", en: "Night Vision" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ფერადი ღამის ხედვა", en: "Color Night Vision" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "განათება", en: "Spotlight" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის დეტექტორი", en: "Motion Detector" },
        value: {
          ka: "კი (ნებისმიერი მოძრაობის; ადამიანის; ბავშვის ტირილის; შინაური ცხოველის)",
          en: "Yes (any motion; human; baby crying; pet)",
        },
      },
      {
        key: {
          ka: "მოძრაობის დაფიქსირებისას შეტყობინება",
          en: "Notification on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "სიგნალიზაცია", en: "Alarm" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის თრექინგი", en: "Motion Tracking" },
        value: { ka: "კი (360°)", en: "Yes (360°)" },
      },
      {
        key: {
          ka: "ორმხრივი აუდიო კომუნიკაცია",
          en: "Two-way Audio Communication",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: {
          ka: "SD Card (არ მოყვება), Homebase 3, Cloud Storage",
          en: "SD Card (not included), Homebase 3, Cloud Storage",
        },
      },
      {
        key: { ka: "ჩაწერის მეთოდი", en: "Recording Method" },
        value: {
          ka: "24/7 და მოძრაობის დაფიქსირებისას",
          en: "24/7 and on motion detection",
        },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ჭკვიანი ინტეგრაციები", en: "Smart Integrations" },
        value: {
          ka: "Google Assistant, Amazon Alexa, Apple Homekit",
          en: "Google Assistant, Amazon Alexa, Apple Homekit",
        },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "არა", en: "No" },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: { ka: "Wi-Fi (2.4GHz)", en: "Wi-Fi (2.4GHz)" },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: {
          ka: "5V/2A USB კაბელი და ადაპტერი",
          en: "5V/2A USB cable and adapter",
        },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "0°C-დან 40°C-მდე", en: "0°C to 40°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>კამერა</li>
              <li>USB ადაპტერი</li>
              <li>USB-C კაბელი (2 მეტრი)</li>
              <li>სამაგრი</li>
              <li>ჭანჭიკები</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Camera</li>
              <li>USB adapter</li>
              <li>USB-C cable (2 meters)</li>
              <li>Mount</li>
              <li>Screws</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "eufy-IndoorCam-S350",
    imageUrl: "/images/products/eufy-indoorcam-s350.webp",
    title: "eufy Indoor Cam S350",
    stock: 3,
    price: 399,
    oldPrice: 399,
    upsell: ["SanDisk-Ultra-128GB", "eufy-HomeBase-S380"],
    description: [
      {
        key: { ka: "რეზოლუცია:", en: "Resolution:" },
        value: { ka: "4K + 2K", en: "4K + 2K" },
      },
      {
        key: { ka: "ხედვის არეალი:", en: "Field of View:" },
        value: { ka: "130°-360°", en: "130°-360°" },
      },
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "Wi-Fi", en: "Wi-Fi" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: { ka: "USB კაბელი", en: "USB cable" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "ორმაგი კამერა:", en: "Dual Camera:" },
        value: {
          ka: "4K ფართოკუთხიანი და 2K ტელეფოტო კამერები ერთად 8x ჰიბრიდულ ზუმს უზრუნველყოფს.",
          en: "The 4K wide-angle and 2K telephoto cameras work together for 8x hybrid zoom.",
        },
      },
      {
        key: { ka: "ჩაწერა:", en: "Recording:" },
        value: {
          ka: "კამერა ჩაიწერს უწყვეტად ან მხოლოდ მოძრაობის დაფიქსირებისას.",
          en: "The camera records continuously or only when motion is detected.",
        },
      },
      {
        key: { ka: "მოძრაობის თრექინგი:", en: "Motion Tracking:" },
        value: {
          ka: "კამერას შეუძლია ადამიანისა და შინაური ცხოველის ავტომატური თრექინგი 360°-ით.",
          en: "The camera automatically tracks people and pets 360°.",
        },
      },
      {
        key: { ka: "ღამის ხედვა:", en: "Night Vision:" },
        value: {
          ka: "ინფრაწითელი განათება უზრუნველყოფს ღამის ხედვას 12 მეტრამდე.",
          en: "Infrared lights provide night vision up to 12 meters.",
        },
      },
      {
        key: { ka: "აუდიო კომუნიკაცია:", en: "Audio Communication:" },
        value: {
          ka: "დაელაპარაკე კამერასთან მყოფებს აპლიკაციით.",
          en: "Talk to people near the camera via the app.",
        },
      },
      {
        key: {
          ka: "ჭკვიანი სახლის ინტეგრაციები:",
          en: "Smart Home Integrations:",
        },
        value: {
          ka: "Amazon Alexa, Google Assistant",
          en: "Amazon Alexa, Google Assistant",
        },
      },
    ],
    video: "https://www.youtube.com/embed/DXsJ-BL_AHM",
    specs: [
      {
        key: { ka: "რეზოლუცია", en: "Resolution" },
        value: {
          ka: "4K (3840 x 2160) + 2K (2304 x 1296)",
          en: "4K (3840 x 2160) + 2K (2304 x 1296)",
        },
      },
      {
        key: { ka: "ზუმი", en: "Zoom" },
        value: { ka: "8x ჰიბრიდული", en: "8x hybrid" },
      },
      {
        key: {
          ka: "სტატიკური ფართო ხედვის არეალი",
          en: "Static Wide Field of View",
        },
        value: { ka: "130°", en: "130°" },
      },
      {
        key: { ka: "დინამიური ხედვის არეალი", en: "Dynamic Field of View" },
        value: {
          ka: (
            <>
              <p>360° ჰორიზონტალურად</p>
              <p>75° ვერტიკალურად</p>
            </>
          ),
          en: (
            <>
              <p>360° horizontally</p>
              <p>75° vertically</p>
            </>
          ),
        },
      },
      {
        key: { ka: "ღამის ხედვა", en: "Night Vision" },
        value: {
          ka: "კი (ინფრაწითელი, 12 მეტრამდე)",
          en: "Yes (infrared, up to 12 meters)",
        },
      },
      {
        key: { ka: "მოძრაობის დეტექტორი", en: "Motion Detector" },
        value: {
          ka: "კი (ნებისმიერი მოძრაობის; ადამიანის; ბავშვის ტირილის; შინაური ცხოველის)",
          en: "Yes (any motion; human; baby crying; pet)",
        },
      },
      {
        key: {
          ka: "მოძრაობის დაფიქსირებისას შეტყობინება",
          en: "Notification on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის თრექინგი", en: "Motion Tracking" },
        value: { ka: "კი (360°)", en: "Yes (360°)" },
      },
      {
        key: {
          ka: "ორმხრივი აუდიო კომუნიკაცია",
          en: "Two-way Audio Communication",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: {
          ka: "microSD Card 128GB-მდე (არ მოყვება), Homebase 3, Cloud Storage",
          en: "microSD Card up to 128GB (not included), Homebase 3, Cloud Storage",
        },
      },
      {
        key: { ka: "ჩაწერის მეთოდი", en: "Recording Method" },
        value: {
          ka: "24/7 და მოძრაობის დაფიქსირებისას",
          en: "24/7 and on motion detection",
        },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ჭკვიანი ინტეგრაციები", en: "Smart Integrations" },
        value: {
          ka: "Google Assistant, Amazon Alexa",
          en: "Google Assistant, Amazon Alexa",
        },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "არა", en: "No" },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: {
          ka: "Wi-Fi (2.4GHz / 5GHz)",
          en: "Wi-Fi (2.4GHz / 5GHz)",
        },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: {
          ka: "5V/2A USB კაბელი და ადაპტერი",
          en: "5V/2A USB cable and adapter",
        },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "0°C-დან 40°C-მდე", en: "0°C to 40°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>კამერა</li>
              <li>USB ადაპტერი</li>
              <li>USB-C კაბელი (2 მეტრი)</li>
              <li>სამაგრი</li>
              <li>პოზიციონირების სტიკერი</li>
              <li>ჭანჭიკები</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Camera</li>
              <li>USB adapter</li>
              <li>USB-C cable (2 meters)</li>
              <li>Mount</li>
              <li>Positioning sticker</li>
              <li>Screws</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
];

export const OUTDOOR_SECURITY_CAMERAS = [
  {
    id: "eufy-SoloCam-S220",
    imageUrl: "/images/products/eufy-solocam-s220.webp",
    title: "eufy SoloCam S220",
    label: "basic",
    stock: 10,
    price: 199,
    oldPrice: 299,
    upsell: ["eufy-Solar-Panel-3W", "eufy-HomeBase-S380"],
    description: [
      {
        key: { ka: "რეზოლუცია:", en: "Resolution:" },
        value: { ka: "2K", en: "2K" },
      },
      {
        key: { ka: "ხედვის არეალი:", en: "Field of View:" },
        value: { ka: "135°", en: "135°" },
      },
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "Wi-Fi", en: "Wi-Fi" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: { ka: "ბატარეა და მზის პანელი", en: "Battery and solar panel" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "ჩაშენებული მზის პანელი:", en: "Built-in Solar Panel:" },
        value: {
          ka: "მზის პანელი უზრუნველყოფს კამერის ბატარეის ყოველდღიურ დამუხტვას.",
          en: "The solar panel provides daily charging for the camera's battery.",
        },
      },
      {
        key: { ka: "მონიტორინგი:", en: "Monitoring:" },
        value: {
          ka: "ნებისმიერ დროს, ნებისმიერი ადგილიდან ლაივში აპლიკაციით ნახე ყველა მნიშვნელოვანი მომენტი 2K ხარისხში.",
          en: "Watch all important moments live in 2K quality anytime, anywhere via the app.",
        },
      },
      {
        key: { ka: "აუდიო კომუნიკაცია:", en: "Audio Communication:" },
        value: {
          ka: "დაელაპარაკე კამერასთან მყოფებს აპლიკაციით.",
          en: "Talk to people near the camera via the app.",
        },
      },
      {
        key: {
          ka: "ჭკვიანი სახლის ინტეგრაციები:",
          en: "Smart Home Integrations:",
        },
        value: {
          ka: "Amazon Alexa, Google Assistant",
          en: "Amazon Alexa, Google Assistant",
        },
      },
      {
        key: (
          <Link
            className="underline"
            to="https://www.eufy.com/privacy-commitment"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang="ka">კონფიდენციალური და დაშიფრული:</span>
            <span lang="en">Confidential and Encrypted:</span>
          </Link>
        ),
        value: {
          ka: "ჩანაწერები ინახება მხოლოდ შენს კამერაში და დაშიფრულია AES-128 ალგორითმით, ლაივ კავშირი კი დაცული და უსაფრთხოა.",
          en: "Recordings are stored only on your camera and encrypted with AES-128. Live connection is protected and secure.",
        },
      },
    ],
    video: "https://www.youtube.com/embed/KiSxCBObplU?si=lF07WBPyjlIFULoX",
    specs: [
      {
        key: { ka: "რეზოლუცია", en: "Resolution" },
        value: { ka: "2K (2560 x 1440)", en: "2K (2560 x 1440)" },
      },
      {
        key: { ka: "ფართო ხედვის არეალი", en: "Wide Field of View" },
        value: { ka: "135°", en: "135°" },
      },
      {
        key: { ka: "მზის პანელი", en: "Solar Panel" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ღამის ხედვა", en: "Night Vision" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის დეტექტორი", en: "Motion Detector" },
        value: {
          ka: "კი (ნებისმიერი მოძრაობის; ადამიანის; შინაური ცხოველის)",
          en: "Yes (any motion; human; pet)",
        },
      },
      {
        key: {
          ka: "მოძრაობის დაფიქსირებისას შეტყობინება",
          en: "Notification on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ვიდეო-ჩანაწერის შენახვა მოძრაობის დაფიქსირებისას", en: "Recording on Motion Detection" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ვიდეო-ჩანაწერის შენახვა მუდმივად (24/7)", en: "Continuous Recording (24/7)" },
        value: { ka: "არა", en: "No" },
      },
      {
        key: { ka: "სიგნალიზაცია", en: "Alarm" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: {
          ka: "ორმხრივი აუდიო კომუნიკაცია",
          en: "Two-way Audio Communication",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: { ka: "8 GB eMMC, HomeBase 3", en: "8 GB eMMC, HomeBase 3" },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ჭკვიანი ინტეგრაციები", en: "Smart Integrations" },
        value: {
          ka: "Google Assistant, Amazon Alexa",
          en: "Google Assistant, Amazon Alexa",
        },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "კი (IP67)", en: "Yes (IP67)" },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: { ka: "Wi-Fi (2.4GHz)", en: "Wi-Fi (2.4GHz)" },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: { ka: "ბატარეა და მზის პანელი", en: "Battery and solar panel" },
      },
      {
        key: { ka: "ბატარეა", en: "Battery" },
        value: { ka: "6500 mAh", en: "6500 mAh" },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "-20°C-დან 50°C-მდე", en: "-20°C to 50°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>კამერა</li>
              <li>USB-C კაბელი</li>
              <li>სამაგრი</li>
              <li>ჭანჭიკები</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Camera</li>
              <li>USB-C cable</li>
              <li>Mount</li>
              <li>Screws</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "eufy-SoloCam-S340",
    imageUrl: "/images/products/eufy-solocam-s340.webp",
    title: "eufy SoloCam S340",
    label: "popular",
    stock: 10,
    price: 599,
    oldPrice: 699,
    upsell: ["Camera-Protector-eufy-SoloCam-S340", "eufy-HomeBase-S380"],
    description: [
      {
        key: { ka: "რეზოლუცია:", en: "Resolution:" },
        value: { ka: "3K + 2K", en: "3K + 2K" },
      },
      {
        key: { ka: "ხედვის არეალი:", en: "Field of View:" },
        value: { ka: "135°-360°", en: "135°-360°" },
      },
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "Wi-Fi", en: "Wi-Fi" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: { ka: "ბატარეა და მზის პანელი", en: "Battery and solar panel" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "მზის პანელი:", en: "Solar Panel:" },
        value: {
          ka: "მზის პანელი უზრუნველყოფს კამერის ბატარეის ყოველდღიურ დამუხტვას.",
          en: "The solar panel provides daily charging for the camera's battery.",
        },
      },
      {
        key: { ka: "მონიტორინგი:", en: "Monitoring:" },
        value: {
          ka: "ნებისმიერ დროს, ნებისმიერი ადგილიდან ლაივში აპლიკაციით ნახე ყველა მნიშვნელოვანი მომენტი 3K ხარისხში.",
          en: "Watch all important moments live in 3K quality anytime, anywhere via the app.",
        },
      },
      {
        key: {
          ka: "განათება და ფერადი ღამის ხედვა:",
          en: "Lighting and Color Night Vision:",
        },
        value: {
          ka: "მკაფიო გამოსახულება დღისა და ღამის განმავლობაში.",
          en: "Clear image day and night.",
        },
      },
      {
        key: { ka: "აუდიო კომუნიკაცია:", en: "Audio Communication:" },
        value: {
          ka: "დაელაპარაკე კამერასთან მყოფებს აპლიკაციით.",
          en: "Talk to people near the camera via the app.",
        },
      },
      {
        key: {
          ka: "ჭკვიანი სახლის ინტეგრაციები:",
          en: "Smart Home Integrations:",
        },
        value: {
          ka: "Amazon Alexa, Google Assistant",
          en: "Amazon Alexa, Google Assistant",
        },
      },
      {
        key: (
          <Link
            className="underline"
            to="https://www.eufy.com/privacy-commitment"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang="ka">კონფიდენციალური და დაშიფრული:</span>
            <span lang="en">Confidential and Encrypted:</span>
          </Link>
        ),
        value: {
          ka: "ჩანაწერები ინახება მხოლოდ შენს კამერაში და დაშიფრულია AES-128 ალგორითმით, ლაივ კავშირი კი დაცული და უსაფრთხოა.",
          en: "Recordings are stored only on your camera and encrypted with AES-128. Live connection is protected and secure.",
        },
      },
    ],
    video: "https://www.youtube.com/embed/_gR3p1IyrzM?si=CgD7Afxgnh8SQzgQ",
    specs: [
      {
        key: { ka: "რეზოლუცია", en: "Resolution" },
        value: {
          ka: (
            <>
              <p>ფართო კუთხოვანი: 3K (2880x1620)</p>
              <p>ტელეფოტო: 2K (2304x1296)</p>
            </>
          ),
          en: (
            <>
              <p>Wide angle: 3K (2880x1620)</p>
              <p>Telephoto: 2K (2304x1296)</p>
            </>
          ),
        },
      },
      {
        key: {
          ka: "სტატიკური ფართო ხედვის არეალი",
          en: "Static Wide Field of View",
        },
        value: { ka: "135°", en: "135°" },
      },
      {
        key: { ka: "დინამიური ხედვის არეალი", en: "Dynamic Field of View" },
        value: {
          ka: (
            <>
              <p>360° ჰორიზონტალურად</p>
              <p>60° ვერტიკალურად</p>
            </>
          ),
          en: (
            <>
              <p>360° horizontally</p>
              <p>60° vertically</p>
            </>
          ),
        },
      },
      {
        key: { ka: "გადიდება/Zoom", en: "Zoom" },
        value: { ka: "8x", en: "8x" },
      },
      {
        key: { ka: "განათება", en: "Lighting" },
        value: { ka: "კი (100 Lumen)", en: "Yes (100 Lumen)" },
      },
      {
        key: { ka: "ფერადი ღამის ხედვა", en: "Color Night Vision" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის დეტექტორი", en: "Motion Detector" },
        value: {
          ka: "კი (ნებისმიერი მოძრაობის; ადამიანის; ავტომობილის)",
          en: "Yes (any motion; human; vehicle)",
        },
      },
      {
        key: {
          ka: "მოძრაობის დაფიქსირებისას შეტყობინება",
          en: "Notification on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის თრექინგი", en: "Motion Tracking" },
        value: { ka: "კი (360°)", en: "Yes (360°)" },
      },
      {
        key: { ka: "ვიდეო-ჩანაწერის შენახვა მოძრაობის დაფიქსირებისას", en: "Recording on Motion Detection" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ვიდეო-ჩანაწერის შენახვა მუდმივად (24/7)", en: "Continuous Recording (24/7)" },
        value: { ka: "არა", en: "No" },
      },
      {
        key: { ka: "სიგნალიზაცია", en: "Alarm" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: {
          ka: "ორმხრივი აუდიო კომუნიკაცია",
          en: "Two-way Audio Communication",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: { ka: "8 GB eMMC, HomeBase 3", en: "8 GB eMMC, HomeBase 3" },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ჭკვიანი ინტეგრაციები", en: "Smart Integrations" },
        value: {
          ka: "Google Assistant, Amazon Alexa",
          en: "Google Assistant, Amazon Alexa",
        },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "კი (IP67)", en: "Yes (IP67)" },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: { ka: "Wi-Fi (2.4GHz)", en: "Wi-Fi (2.4GHz)" },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: { ka: "ბატარეა და მზის პანელი", en: "Battery and solar panel" },
      },
      {
        key: { ka: "მზის პანელი", en: "Solar Panel" },
        value: { ka: "კი (2.2W)", en: "Yes (2.2W)" },
      },
      {
        key: { ka: "ბატარეა", en: "Battery" },
        value: { ka: "10000 mAh", en: "10000 mAh" },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "-20°C-დან 50°C-მდე", en: "-20°C to 50°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>კამერა</li>
              <li>მზის პანელი</li>
              <li>2x USB-C კაბელი</li>
              <li>2x სამაგრი</li>
              <li>2x ჭანჭიკები</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Camera</li>
              <li>Solar panel</li>
              <li>2x USB-C cable</li>
              <li>2x mount</li>
              <li>2x screws</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "eufy-4G-LTE-Cam-S330",
    imageUrl: "/images/products/eufy-4g-lte-cam-S330.webp",
    title: "eufy 4G LTE Cam S330",
    label: "sim-card",
    stock: 1,
    price: 899,
    oldPrice: 999,
    upsell: [
      "Camera-Protector-eufy-4G-LTE-Cam-S330",
      "SanDisk-Ultra-128GB",
      "eufy-HomeBase-S380",
    ],
    description: [
      {
        key: { ka: "რეზოლუცია:", en: "Resolution:" },
        value: { ka: "4K", en: "4K" },
      },
      {
        key: { ka: "ხედვის არეალი:", en: "Field of View:" },
        value: { ka: "138°-360°", en: "138°-360°" },
      },
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "4G LTE და Wi-Fi", en: "4G LTE and Wi-Fi" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: { ka: "ბატარეა და მზის პანელი", en: "Battery and solar panel" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "მზის პანელი:", en: "Solar Panel:" },
        value: {
          ka: "მზის პანელი უზრუნველყოფს კამერის ბატარეის ყოველდღიურ დამუხტვას.",
          en: "The solar panel provides daily charging for the camera's battery.",
        },
      },
      {
        key: { ka: "უწყვეტი კავშირი:", en: "Uninterrupted Connection:" },
        value: {
          ka: "კამერა მუშაობს 4G/LTE სიმ ბარათსა და Wi-Fi-ზე. რომელიმეს შეფერხების შემთხვევაში გადაერთვება ხელმისაწვდომ კავშირზე.",
          en: "The camera works with a 4G/LTE SIM card and Wi-Fi. If one fails, it switches to the available connection.",
        },
      },
      {
        key: { ka: "მონიტორინგი:", en: "Monitoring:" },
        value: {
          ka: "ნებისმიერ დროს, ნებისმიერი ადგილიდან ლაივში აპლიკაციით ნახე ყველა მნიშვნელოვანი მომენტი 4K ხარისხში.",
          en: "Watch all important moments live in 4K quality anytime, anywhere via the app.",
        },
      },
      {
        key: {
          ka: "განათება და ფერადი ღამის ხედვა:",
          en: "Lighting and Color Night Vision:",
        },
        value: {
          ka: "მკაფიო გამოსახულება დღისა და ღამის განმავლობაში.",
          en: "Clear image day and night.",
        },
      },
      {
        key: { ka: "აუდიო კომუნიკაცია:", en: "Audio Communication:" },
        value: {
          ka: "დაელაპარაკე კამერასთან მყოფებს აპლიკაციით.",
          en: "Talk to people near the camera via the app.",
        },
      },
      {
        key: {
          ka: "ჭკვიანი სახლის ინტეგრაციები:",
          en: "Smart Home Integrations:",
        },
        value: {
          ka: "Amazon Alexa, Google Assistant",
          en: "Amazon Alexa, Google Assistant",
        },
      },
      {
        key: (
          <Link
            className="underline"
            to="https://www.eufy.com/privacy-commitment"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang="ka">კონფიდენციალური და დაშიფრული:</span>
            <span lang="en">Confidential and Encrypted:</span>
          </Link>
        ),
        value: {
          ka: "ჩანაწერები ინახება მხოლოდ შენს კამერაში და დაშიფრულია AES-128 ალგორითმით, ლაივ კავშირი კი დაცული და უსაფრთხოა.",
          en: "Recordings are stored only on your camera and encrypted with AES-128. Live connection is protected and secure.",
        },
      },
    ],
    video: "https://www.youtube.com/embed/28oANXDJUXA?si=qJmsrJNakBGyIgTb",
    specs: [
      {
        key: { ka: "რეზოლუცია", en: "Resolution" },
        value: { ka: "4K (3840×2160)", en: "4K (3840×2160)" },
      },
      {
        key: {
          ka: "სტატიკური ფართო ხედვის არეალი",
          en: "Static Wide Field of View",
        },
        value: { ka: "138°", en: "138°" },
      },
      {
        key: { ka: "დინამიური ხედვის არეალი", en: "Dynamic Field of View" },
        value: {
          ka: (
            <>
              <p>360° ჰორიზონტალურად</p>
              <p>70° ვერტიკალურად</p>
            </>
          ),
          en: (
            <>
              <p>360° horizontally</p>
              <p>70° vertically</p>
            </>
          ),
        },
      },
      {
        key: { ka: "გადიდება/Zoom", en: "Zoom" },
        value: { ka: "8x", en: "8x" },
      },
      {
        key: { ka: "განათება", en: "Lighting" },
        value: { ka: "კი (100 Lumen)", en: "Yes (100 Lumen)" },
      },
      {
        key: { ka: "ფერადი ღამის ხედვა", en: "Color Night Vision" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის დეტექტორი", en: "Motion Detector" },
        value: {
          ka: "კი (ნებისმიერი მოძრაობის; ადამიანის; ავტომობილის)",
          en: "Yes (any motion; human; vehicle)",
        },
      },
      {
        key: {
          ka: "მოძრაობის დაფიქსირებისას შეტყობინება",
          en: "Notification on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის თრექინგი", en: "Motion Tracking" },
        value: { ka: "კი (360°)", en: "Yes (360°)" },
      },
      {
        key: { ka: "ვიდეო-ჩანაწერის შენახვა მოძრაობის დაფიქსირებისას", en: "Recording on Motion Detection" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ვიდეო-ჩანაწერის შენახვა მუდმივად (24/7)", en: "Continuous Recording (24/7)" },
        value: { ka: "არა", en: "No" },
      },
      {
        key: { ka: "სიგნალიზაცია", en: "Alarm" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: {
          ka: "ორმხრივი აუდიო კომუნიკაცია",
          en: "Two-way Audio Communication",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: {
          ka: "SD Card (მოყვება 32 GB), HomeBase 3",
          en: "SD Card (32 GB included), HomeBase 3",
        },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ჭკვიანი ინტეგრაციები", en: "Smart Integrations" },
        value: {
          ka: "Google Assistant, Amazon Alexa",
          en: "Google Assistant, Amazon Alexa",
        },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "კი (IP55)", en: "Yes (IP55)" },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: {
          ka: "4G LTE და Wi-Fi (2.4GHz)",
          en: "4G LTE and Wi-Fi (2.4GHz)",
        },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: { ka: "ბატარეა და მზის პანელი", en: "Battery and solar panel" },
      },
      {
        key: { ka: "მზის პანელი", en: "Solar Panel" },
        value: { ka: "კი (4.5W)", en: "Yes (4.5W)" },
      },
      {
        key: { ka: "ბატარეა", en: "Battery" },
        value: { ka: "9400 mAh", en: "9400 mAh" },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "-20°C-დან 50°C-მდე", en: "-20°C to 50°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>კამერა</li>
              <li>მზის პანელი</li>
              <li>SD Card (32 GB)</li>
              <li>2x USB-C კაბელი</li>
              <li>2x სამაგრი</li>
              <li>2x ჭანჭიკები</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Camera</li>
              <li>Solar panel</li>
              <li>SD Card (32 GB)</li>
              <li>2x USB-C cable</li>
              <li>2x mount</li>
              <li>2x screws</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "eufyCam-S4",
    imageUrl: "/images/products/eufycam-s4.webp",
    title: "eufyCam S4",
    label: "best-choice",
    stock: 0,
    price: 1099,
    oldPrice: 1199,
    upsell: ["SanDisk-Ultra-128GB", "eufy-HomeBase-S380"],
    description: [
      {
        key: { ka: "რეზოლუცია:", en: "Resolution:" },
        value: { ka: "4K + 2K + 2K", en: "4K + 2K + 2K" },
      },
      {
        key: { ka: "ხედვის არეალი:", en: "Field of View:" },
        value: { ka: "130°-360°", en: "130°-360°" },
      },
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "Wi-Fi", en: "Wi-Fi" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: {
          ka: "ბატარეა და მზის პანელი ან კაბელი",
          en: "Battery, solar panel, or cable",
        },
      },
    ],
    shortDescription: [
      {
        key: { ka: "სამი ლინზა:", en: "Three Lenses:" },
        value: {
          ka: "4K ფიქსირებული ფართო ლინზა მთელ ეზოს გადაიღებს, ქვედა მბრუნავი ორლინზიანი კამერა კი 360°-ზე მიჰყვება მოძრაობას და აახლოვებს დეტალებს.",
          en: "The 4K fixed wide lens covers the whole yard, while the lower pan-and-tilt dual-lens camera tracks motion across 360° and zooms in on details.",
        },
      },
      {
        key: { ka: "მზის პანელი:", en: "Solar Panel:" },
        value: {
          ka: "დღეში მხოლოდ 1 საათი მზის შუქი საკმარისია კამერის დამუხტვისთვის.",
          en: "Just 1 hour of sunlight a day is enough to keep the camera charged.",
        },
      },
      {
        key: {
          ka: "უწყვეტი ჩაწერა (24/7):",
          en: "Continuous Recording (24/7):",
        },
        value: {
          ka: "მზის პანელის ნაცვლად კამერა დენზე რომ ჩართო, ჩაწერს უწყვეტად, 24/7 რეჟიმში.",
          en: "Plug the camera into power instead of using the solar panel and it records continuously, 24/7.",
        },
      },
      {
        key: { ka: "მონიტორინგი:", en: "Monitoring:" },
        value: {
          ka: "ნებისმიერ დროს, ნებისმიერი ადგილიდან ლაივში აპლიკაციით ნახე ყველა მნიშვნელოვანი მომენტი 4K ხარისხში.",
          en: "Watch all important moments live in 4K quality anytime, anywhere via the app.",
        },
      },
      {
        key: {
          ka: "განათება და ფერადი ღამის ხედვა:",
          en: "Lighting and Color Night Vision:",
        },
        value: {
          ka: "მკაფიო გამოსახულება დღისა და ღამის განმავლობაში.",
          en: "Clear image day and night.",
        },
      },
      {
        key: { ka: "აუდიო კომუნიკაცია:", en: "Audio Communication:" },
        value: {
          ka: "დაელაპარაკე კამერასთან მყოფებს აპლიკაციით.",
          en: "Talk to people near the camera via the app.",
        },
      },
      {
        key: {
          ka: "ჭკვიანი სახლის ინტეგრაციები:",
          en: "Smart Home Integrations:",
        },
        value: {
          ka: "Amazon Alexa, Google Assistant",
          en: "Amazon Alexa, Google Assistant",
        },
      },
      {
        key: (
          <Link
            className="underline"
            to="https://www.eufy.com/privacy-commitment"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span lang="ka">კონფიდენციალური და დაშიფრული:</span>
            <span lang="en">Confidential and Encrypted:</span>
          </Link>
        ),
        value: {
          ka: "ჩანაწერები ინახება მხოლოდ შენს კამერაში და დაშიფრულია AES-128 ალგორითმით, ლაივ კავშირი კი დაცული და უსაფრთხოა.",
          en: "Recordings are stored only on your camera and encrypted with AES-128. Live connection is protected and secure.",
        },
      },
    ],
    video: "https://www.youtube.com/embed/I3ePfRNrqR8?si=zZUpqz_cxFD4pVnP",
    specs: [
      {
        key: { ka: "რეზოლუცია", en: "Resolution" },
        value: {
          ka: (
            <>
              <p>ფიქსირებული კამერა: 4K (3840x2160)</p>
              <p>მბრუნავი კამერა: 2K + 2K (2688x1520)</p>
            </>
          ),
          en: (
            <>
              <p>Fixed camera: 4K (3840x2160)</p>
              <p>PTZ camera: 2K + 2K (2688x1520)</p>
            </>
          ),
        },
      },
      {
        key: {
          ka: "სტატიკური ფართო ხედვის არეალი",
          en: "Static Wide Field of View",
        },
        value: { ka: "130°", en: "130°" },
      },
      {
        key: { ka: "დინამიური ხედვის არეალი", en: "Dynamic Field of View" },
        value: {
          ka: (
            <>
              <p>360° ჰორიზონტალურად</p>
              <p>70° ვერტიკალურად</p>
            </>
          ),
          en: (
            <>
              <p>360° horizontally</p>
              <p>70° vertically</p>
            </>
          ),
        },
      },
      {
        key: { ka: "გადიდება/Zoom", en: "Zoom" },
        value: { ka: "8x", en: "8x" },
      },
      {
        key: { ka: "განათება", en: "Lighting" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ფერადი ღამის ხედვა", en: "Color Night Vision" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის დეტექტორი", en: "Motion Detector" },
        value: {
          ka: "კი (ნებისმიერი მოძრაობის; ადამიანის; ავტომობილის; ცხოველის)",
          en: "Yes (any motion; human; vehicle; pet)",
        },
      },
      {
        key: {
          ka: "მოძრაობის დაფიქსირებისას შეტყობინება",
          en: "Notification on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მოძრაობის თრექინგი", en: "Motion Tracking" },
        value: { ka: "კი (360°)", en: "Yes (360°)" },
      },
      {
        key: {
          ka: "ვიდეო-ჩანაწერის შენახვა მოძრაობის დაფიქსირებისას",
          en: "Recording on Motion Detection",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: {
          ka: "ვიდეო-ჩანაწერის შენახვა მუდმივად (24/7)",
          en: "Continuous Recording (24/7)",
        },
        value: { ka: "კი (დენზე ჩართვისას)", en: "Yes (when plugged into power)" },
      },
      {
        key: { ka: "სიგნალიზაცია", en: "Alarm" },
        value: { ka: "კი (105 dB)", en: "Yes (105 dB)" },
      },
      {
        key: {
          ka: "ორმხრივი აუდიო კომუნიკაცია",
          en: "Two-way Audio Communication",
        },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: {
          ka: "32 GB eMMC, microSD Card 256 GB-მდე (არ მოყვება), HomeBase 3",
          en: "32 GB eMMC, microSD Card up to 256 GB (not included), HomeBase 3",
        },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ჭკვიანი ინტეგრაციები", en: "Smart Integrations" },
        value: {
          ka: "Google Assistant, Amazon Alexa",
          en: "Google Assistant, Amazon Alexa",
        },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "კი (IP65)", en: "Yes (IP65)" },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: { ka: "Wi-Fi (2.4GHz)", en: "Wi-Fi (2.4GHz)" },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: {
          ka: "ბატარეა და მზის პანელი ან კაბელი",
          en: "Battery, solar panel, or cable",
        },
      },
      {
        key: { ka: "მზის პანელი", en: "Solar Panel" },
        value: { ka: "კი (5.5W)", en: "Yes (5.5W)" },
      },
      {
        key: { ka: "ბატარეა", en: "Battery" },
        value: { ka: "10000 mAh (მოსახსნელი)", en: "10000 mAh (removable)" },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "-20°C-დან 55°C-მდე", en: "-20°C to 55°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>კამერა</li>
              <li>ბატარეა</li>
              <li>მზის პანელი სამაგრით</li>
              <li>USB-C კაბელი (1.2 მ)</li>
              <li>დამაგრძელებელი კაბელი (3 მ)</li>
              <li>სამაგრი</li>
              <li>ჭანჭიკები</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Camera</li>
              <li>Battery</li>
              <li>Solar panel with bracket</li>
              <li>USB-C cable (1.2 m)</li>
              <li>Extension cable (3 m)</li>
              <li>Mount</li>
              <li>Screws</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
];

export const OTHER = [
  {
    id: "eufy-HomeBase-S380",
    imageUrl: "/images/products/eufy-homebase-s380.webp",
    title: "eufy HomeBase S380 (HomeBase 3)",
    stock: 5,
    // price: 499,
    price: 529,
    oldPrice: 529,
    description: [
      {
        key: { ka: "კავშირი:", en: "Connection:" },
        value: { ka: "Wi-Fi და LAN", en: "Wi-Fi and LAN" },
      },
      {
        key: { ka: "მეხსიერება:", en: "Storage:" },
        value: { ka: "16 GB (16 TB-მდე)", en: "16 GB (up to 16 TB)" },
      },
      {
        key: { ka: "სახის ამოცნობა:", en: "Face Recognition:" },
        value: { ka: "BionicMind™", en: "BionicMind™" },
      },
      {
        key: { ka: "კვების წყარო:", en: "Power Source:" },
        value: { ka: "USB კაბელი", en: "USB cable" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "ცენტრალიზებული მეხსიერება:", en: "Centralized Storage:" },
        value: {
          ka: "იუფის მოწყობილობების დაკავშირების შემდეგ ყველა ჩანაწერი შეინახება HomeBase 3-ზე.",
          en: "After connecting Eufy devices, all recordings are stored on HomeBase 3.",
        },
      },
      {
        key: { ka: "გაზრდადი მეხსიერება:", en: "Expandable Storage:" },
        value: {
          ka: "შიდა 16 GB მეხსიერების გარდა, შესაძლებელია მყარი დისკის ინსტალაცია, რაც 16 TB-მდე ზრდის მეხსიერებას.",
          en: "In addition to built-in 16 GB, you can install a hard drive to expand up to 16 TB.",
        },
      },
      {
        key: { ka: "BionicMind™ AI:", en: "BionicMind™ AI:" },
        value: {
          ka: "კამერების HomeBase 3-თან დაკავშირების შემდეგ კამერებზე აქტიურდება სახის ამოცნობის ფუნქცია, რათა მოხდეს ოჯახის წევრებისა და უცნობების განსხვავება.",
          en: "After connecting cameras to HomeBase 3, face recognition is activated to distinguish family members and strangers.",
        },
      },
      {
        key: { ka: "დაცული და დაშიფრული:", en: "Protected and Encrypted:" },
        value: {
          ka: "მოწყობილობაზე შენახული ჩანაწერები დაშიფრულია AES-128 და RSA-1024 ალგორითმით.",
          en: "Recordings stored on the device are encrypted with AES-128 and RSA-1024.",
        },
      },
    ],
    video:
      "https://www.youtube.com/embed/MrdabEBWgkg?si=10Ir_4WR0UHuXObd&amp;start=11",
    specs: [
      {
        key: { ka: "დაკავშირების რაოდენობა", en: "Number of Connections" },
        value: {
          ka: (
            <ul>
              <li>16-მდე მოწყობილობა</li>
              <li>34-მდე სენსორი</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Up to 16 devices</li>
              <li>Up to 34 sensors</li>
            </ul>
          ),
        },
      },
      {
        key: { ka: "AI ამოცნობა", en: "AI Recognition" },
        value: {
          ka: (
            <ul>
              <li>თვით-სწავლის ალგორითმი</li>
              <li>სახის ამოცნობა</li>
              <li>ადამიანის დაფიქსირება</li>
              <li>ავტომობილის დაფიქსირება</li>
              <li>შინაური ცხოველის დაფიქსირება</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Self-learning algorithm</li>
              <li>Face recognition</li>
              <li>Human detection</li>
              <li>Vehicle detection</li>
              <li>Pet detection</li>
            </ul>
          ),
        },
      },
      {
        key: { ka: "სიგნალიზაცია", en: "Alarm" },
        value: { ka: "კი (100db)", en: "Yes (100db)" },
      },
      {
        key: { ka: "აპლიკაციით მართვა", en: "App Control" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "მეხსიერება", en: "Storage" },
        value: {
          ka: (
            <ul>
              <li>შიდა მეხსიერება: 16 GB eMMC</li>
              <li>მყარი დისკი: 16 TB-მდე (არ მოყვება)</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Internal storage: 16 GB eMMC</li>
              <li>Hard drive: up to 16 TB (not included)</li>
            </ul>
          ),
        },
      },
      {
        key: { ka: "პროცესორი", en: "Processor" },
        value: {
          ka: "Quad-core ARM Cortex-A55",
          en: "Quad-core ARM Cortex-A55",
        },
      },
      {
        key: { ka: "კავშირი", en: "Connection" },
        value: {
          ka: (
            <>
              <p>Wi-Fi (2.4GHz)</p>
              <p>LAN (10/100/1000 Mbps)</p>
            </>
          ),
          en: (
            <>
              <p>Wi-Fi (2.4GHz)</p>
              <p>LAN (10/100/1000 Mbps)</p>
            </>
          ),
        },
      },
      {
        key: {
          ka: "ჩანაწერების დაშიფვრის ალგორითმები",
          en: "Recording Encryption Algorithms",
        },
        value: { ka: "AES-128 + RSA-1024", en: "AES-128 + RSA-1024" },
      },
      {
        key: { ka: "კვების წყარო", en: "Power Source" },
        value: { ka: "USB კაბელი და ადაპტერი", en: "USB cable and adapter" },
      },
      {
        key: { ka: "სამუშაო ტემპერატურა", en: "Operating Temperature" },
        value: { ka: "-10°C-დან 50°C-მდე", en: "-10°C to 50°C" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>HomeBase 3</li>
              <li>USB-C კაბელი</li>
              <li>ადაპტერი</li>
              <li>ინსტრუქცია</li>
            </ul>
          ),
          en: (
            <ul>
              <li>HomeBase 3</li>
              <li>USB-C cable</li>
              <li>Adapter</li>
              <li>Manual</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "eufy-Solar-Panel-3W",
    imageUrl: "/images/products/eufy-solar-panel-3w.webp",
    title: "eufy Solar Panel (3W)",
    stock: 6,
    price: 119,
    oldPrice: 119,
    description: [
      {
        key: { ka: "სიმძლავრე:", en: "Power:" },
        value: { ka: "3W", en: "3W" },
      },
      {
        key: { ka: "წყალგამძლე:", en: "Water Resistant:" },
        value: { ka: "კი (IP65)", en: "Yes (IP65)" },
      },
      {
        key: { ka: "სამაგრი:", en: "Mount:" },
        value: { ka: "360° ბრუნვადი", en: "360° adjustable" },
      },
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: { ka: "თავსებადია eufy-ს კამერებთან", en: "Compatible with eufy cameras" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "უწყვეტი დამუხტვა:", en: "Continuous Charging:" },
        value: {
          ka: "დღეში რამდენიმე საათი პირდაპირი მზის სხივები საკმარისია, რომ კამერა მუდმივად დამუხტული იყოს.",
          en: "Just a few hours of direct sunlight a day keeps the camera charged around the clock.",
        },
      },
      {
        key: { ka: "eufy-ს კამერები:", en: "eufy Cameras:" },
        value: {
          ka: "თავსებადია eufy-ს კამერებთან.",
          en: "Compatible with eufy cameras.",
        },
      },
      {
        key: { ka: "მარტივი მონტაჟი:", en: "Easy Installation:" },
        value: {
          ka: "კაბელის წყალობით პანელი შეგიძლია ყველაზე მზიან ადგილას დაამონტაჟო, 360°-ით მბრუნავი სამაგრი კი სასურველი კუთხით მიმართვის საშუალებას იძლევა.",
          en: "The cable lets you mount the panel where it gets the most sunlight, and the 360° mount lets you angle it as needed.",
        },
      },
      {
        key: { ka: "ნებისმიერი ამინდისთვის:", en: "Weatherproof:" },
        value: {
          ka: "IP65 სტანდარტი პანელს წვიმისა და მტვრისგან იცავს.",
          en: "The IP65 rating protects the panel from rain and dust.",
        },
      },
      {
        key: { ka: "სერტიფიცირებული უსაფრთხოება:", en: "Certified Safe:" },
        value: {
          ka: "მხოლოდ eufy-ს სერტიფიცირებული მზის პანელები უზრუნველყოფს კამერის კვების სწორ მართვას. არასერტიფიცირებულმა პანელმა შესაძლოა კამერის ბატარეა დააზიანოს.",
          en: "Only certified eufy solar panels ensure correct power management. Non-certified panels may damage the camera battery.",
        },
      },
    ],
    specs: [
      {
        key: { ka: "სიმძლავრე", en: "Power" },
        value: { ka: "3W", en: "3W" },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "კი (IP65)", en: "Yes (IP65)" },
      },
      {
        key: { ka: "სამაგრი", en: "Mount" },
        value: { ka: "360° ბრუნვადი", en: "360° adjustable" },
      },
      {
        key: { ka: "თავსებადობა", en: "Compatibility" },
        value: { ka: "თავსებადია eufy-ს კამერებთან", en: "Compatible with eufy cameras" },
      },
      {
        key: { ka: "კომერციული გარანტია", en: "Commercial Warranty" },
        value: { ka: "1 წელი", en: "1 year" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>მზის პანელი</li>
              <li>სამაგრი</li>
              <li>ჭანჭიკები და დიუბელები</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Solar panel</li>
              <li>Mount</li>
              <li>Screws and wall anchors</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "eufy-USB-C-Power-Cable",
    imageUrl: "/images/products/eufy-usb-c-power-cable.webp",
    title: "eufy USB-C Power Cable (4.5 m)",
    stock: 2,
    price: 69,
    oldPrice: 69,
    description: [
      {
        key: { ka: "სიგრძე:", en: "Length:" },
        value: { ka: "4.5 მ", en: "4.5 m" },
      },
      {
        key: { ka: "კონექტორები:", en: "Connectors:" },
        value: { ka: "USB-A → USB-C", en: "USB-A → USB-C" },
      },
      {
        key: { ka: "წყალგამძლე:", en: "Water Resistant:" },
        value: { ka: "კი", en: "Yes" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "უწყვეტი კვება:", en: "Continuous Power:" },
        value: {
          ka: "კამერა მუდმივად დენზეა, ასე რომ ბატარეის დამუხტვაზე ფიქრი აღარ მოგიწევს.",
          en: "Keeps the camera powered at all times, so you never have to think about charging the battery.",
        },
      },
      {
        key: { ka: "წყალგამძლე შეერთება:", en: "Weatherproof Connection:" },
        value: {
          ka: "USB-C თავზე არსებული შუასადები კამერის პორტს მჭიდროდ ხურავს, ასე რომ წვიმის წყალი კამერაში ვერ მოხვდება.",
          en: "A seal on the USB-C end closes off the camera's port, so rain can't get inside.",
        },
      },
      {
        key: { ka: "გრძელი კაბელი:", en: "Long Cable:" },
        value: {
          ka: "4.5 მეტრიანი კაბელით კამერას როზეტიდან მოშორებითაც დაამონტაჟებ.",
          en: "The 4.5 m cable lets you mount the camera farther from a power outlet.",
        },
      },
      {
        key: { ka: "ადაპტერი:", en: "Adapter:" },
        value: {
          ka: "საჭიროა USB-A ადაპტერი (5V/2A ან მეტი), რომელიც კომპლექტში არ შედის.",
          en: "Requires a USB-A power adapter (5V/2A or higher), not included.",
        },
      },
    ],
    specs: [
      {
        key: { ka: "სიგრძე", en: "Length" },
        value: { ka: "4.5 მ", en: "4.5 m" },
      },
      {
        key: { ka: "კონექტორები", en: "Connectors" },
        value: { ka: "USB-A → USB-C", en: "USB-A → USB-C" },
      },
      {
        key: { ka: "წყალგამძლე", en: "Water Resistant" },
        value: { ka: "კი", en: "Yes" },
      },
      {
        key: { ka: "ადაპტერი", en: "Adapter" },
        value: {
          ka: "USB-A, 5V/2A ან მეტი (არ მოყვება)",
          en: "USB-A, 5V/2A or higher (not included)",
        },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>USB-A–USB-C კაბელი (4.5 მ)</li>
            </ul>
          ),
          en: (
            <ul>
              <li>USB-A to USB-C cable (4.5 m)</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "SanDisk-Ultra-128GB",
    imageUrl: "/images/products/sandisk-ultra-128gb.webp",
    title: "SanDisk Ultra 128 GB microSD",
    stock: 4,
    price: 109,
    oldPrice: 109,
    description: [
      {
        key: { ka: "მოცულობა:", en: "Capacity:" },
        value: { ka: "128 GB", en: "128 GB" },
      },
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: { ka: "თავსებადია eufy-ს კამერებთან", en: "Compatible with eufy cameras" },
      },
      {
        key: { ka: "წაკითხვის სიჩქარე:", en: "Read Speed:" },
        value: { ka: "140 MB/s-მდე", en: "Up to 140 MB/s" },
      }
    ],
    shortDescription: [
      {
        key: { ka: "მაღალი სიჩქარე:", en: "High Speed:" },
        value: {
          ka: "140 MB/s-მდე წაკითხვის სიჩქარე ფაილების სწრაფ გადატანას უზრუნველყოფს.",
          en: "Read speeds up to 140 MB/s enable fast file transfers.",
        },
      },
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: {
          ka: "თავსებადია Android სმარტფონებთან, ტაბლეტებთან და კამერებთან.",
          en: "Compatible with Android smartphones, tablets, and cameras.",
        },
      },
      {
        key: { ka: "eufy-ს კამერები:", en: "eufy Cameras:" },
        value: {
          ka: "თავსებადია eufy-ს კამერებთან.",
          en: "Compatible with eufy cameras.",
        },
      },
    ],
    specs: [
      {
        key: { ka: "სრული დასახელება", en: "Full Name" },
        value: {
          ka: "SanDisk 128GB Ultra MicroSD/HC UHS-I Card 140MB/s Class 10",
          en: "SanDisk 128GB Ultra MicroSD/HC UHS-I Card 140MB/s Class 10",
        },
      },
      {
        key: { ka: "მოცულობა", en: "Capacity" },
        value: { ka: "128 GB", en: "128 GB" },
      },
      {
        key: { ka: "წაკითხვის სიჩქარე", en: "Read Speed" },
        value: { ka: "140 MB/s-მდე", en: "Up to 140 MB/s" },
      },
      {
        key: { ka: "ინტერფეისი", en: "Interface" },
        value: { ka: "UHS-I", en: "UHS-I" },
      },
      {
        key: { ka: "სიჩქარის კლასი", en: "Speed Class" },
        value: { ka: "Class 10 (C10), U1", en: "Class 10 (C10), U1" },
      },
      {
        key: { ka: "აპლიკაციის კლასი", en: "App Performance Class" },
        value: { ka: "A1", en: "A1" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>microSD ბარათი (128 GB)</li>
              <li>SD ადაპტერი</li>
            </ul>
          ),
          en: (
            <ul>
              <li>microSD card (128 GB)</li>
              <li>SD adapter</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "Camera-Protector-eufy-4G-LTE-Cam-S330",
    imageUrl: "/images/products/camera-protector-s330.webp",
    title: {
      ka: "კამერის დამატებითი დამცავი",
      en: "Extra Camera Protector",
    },
    stock: 10,
    price: 79,
    oldPrice: 79,
    description: [
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: { ka: "eufy 4G LTE Cam S330", en: "eufy 4G LTE Cam S330" },
      },
      {
        key: { ka: "მასალა:", en: "Material:" },
        value: { ka: "ABS პლასტმასი", en: "ABS plastic" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: {
          ka: (
            <>
              შექმნილია{" "}
              <Link className="underline" to="/eufy-4G-LTE-Cam-S330">
                eufy 4G LTE Cam S330
              </Link>
              -ისთვის და მჭიდროდ ერგება კამერას.
            </>
          ),
          en: (
            <>
              Designed for the{" "}
              <Link className="underline" to="/en/eufy-4G-LTE-Cam-S330">
                eufy 4G LTE Cam S330
              </Link>{" "}
              for a snug, secure fit.
            </>
          ),
        },
      },
      {
        key: { ka: "კორპუსის დაცვა:", en: "Housing Protection:" },
        value: {
          ka: "იცავს კამერას მზისა და წვიმის შედეგად გამოწვეული ABS პლასტმასის დეგრადაციისგან.",
          en: "Protects the camera's ABS plastic housing from degradation caused by sun and rain.",
        },
      },
      {
        key: { ka: "მკაფიო გამოსახულება:", en: "Clearer View:" },
        value: {
          ka: "კამერა ისედაც წყალგამძლეა (IP55). დამცავი ლინზას წვიმის წვეთებს, თოვლსა და მზის პირდაპირ სხივებს არიდებს, რაც ჩანაწერს უფრო მკაფიოს ხდის.",
          en: "The camera is already water resistant (IP55). The protector keeps raindrops, snow, and direct sunlight off the lens for clearer footage.",
        },
      },
      {
        key: { ka: "ანარეკლის გარეშე:", en: "Anti-Glare:" },
        value: {
          ka: "დამცავის შიდა მხარე მქრქალი შავია, რაც ამცირებს სინათლის ანარეკლს ლინზაზე.",
          en: "The matte black underside reduces light reflections on the lens.",
        },
      },
      {
        key: { ka: "გამძლე მასალა:", en: "Durable Material:" },
        value: {
          ka: "მსუბუქი, მაგრამ მტკიცე ABS პლასტმასი გარე პირობებში ხანგრძლივად გაძლებს.",
          en: "Lightweight yet sturdy ABS plastic built to last outdoors.",
        },
      },
      {
        key: { ka: "მარტივი მონტაჟი:", en: "Easy Installation:" },
        value: {
          ka: "დამცავი კამერაზე მზის პანელის დამაგრებამდე თავსდება და კომპლექტში შემავალი ორმხრივი ლენტით მაგრდება, ბურღვის გარეშე.",
          en: "Fit the protector on the camera before attaching the solar panel and secure it with the included double-sided tape, no drilling required.",
        },
      },
    ],
    specs: [
      {
        key: { ka: "თავსებადობა", en: "Compatibility" },
        value: {
          ka: (
            <Link className="underline" to="/eufy-4G-LTE-Cam-S330">
              eufy 4G LTE Cam S330
            </Link>
          ),
          en: (
            <Link className="underline" to="/en/eufy-4G-LTE-Cam-S330">
              eufy 4G LTE Cam S330
            </Link>
          ),
        },
      },
      {
        key: { ka: "მასალა", en: "Material" },
        value: { ka: "ABS პლასტმასი", en: "ABS plastic" },
      },
      {
        key: { ka: "ფერი", en: "Color" },
        value: { ka: "თეთრი", en: "White" },
      },
      {
        key: { ka: "მონტაჟი", en: "Installation" },
        value: { ka: "ორმხრივი წებოვანი ლენტი", en: "Double-sided tape" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>დამცავი</li>
              <li>ორმხრივი წებოვანი ლენტი</li>
              <li>ჭანჭიკები</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Protector</li>
              <li>Double-sided tape</li>
              <li>Screws</li>
            </ul>
          ),
        },
      },
    ],
  },
  {
    id: "Camera-Protector-eufy-SoloCam-S340",
    imageUrl: "/images/products/camera-protector-s340.webp",
    title: {
      ka: "კამერის დამატებითი დამცავი",
      en: "Extra Camera Protector",
    },
    stock: 1,
    price: 69,
    oldPrice: 69,
    description: [
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: { ka: "eufy SoloCam S340", en: "eufy SoloCam S340" },
      },
      {
        key: { ka: "მასალა:", en: "Material:" },
        value: { ka: "ABS პლასტმასი", en: "ABS plastic" },
      },
    ],
    shortDescription: [
      {
        key: { ka: "თავსებადობა:", en: "Compatibility:" },
        value: {
          ka: (
            <>
              შექმნილია{" "}
              <Link className="underline" to="/eufy-SoloCam-S340">
                eufy SoloCam S340
              </Link>
              -ისთვის და მჭიდროდ ერგება კამერას.
            </>
          ),
          en: (
            <>
              Designed for the{" "}
              <Link className="underline" to="/en/eufy-SoloCam-S340">
                eufy SoloCam S340
              </Link>{" "}
              for a snug, secure fit.
            </>
          ),
        },
      },
      {
        key: { ka: "კორპუსის დაცვა:", en: "Housing Protection:" },
        value: {
          ka: "იცავს კამერას მზისა და წვიმის შედეგად გამოწვეული ABS პლასტმასის დეგრადაციისგან.",
          en: "Protects the camera's ABS plastic housing from degradation caused by sun and rain.",
        },
      },
      {
        key: { ka: "მკაფიო გამოსახულება:", en: "Clearer View:" },
        value: {
          ka: "კამერა ისედაც წყალგამძლეა (IP67). დამცავი ლინზას წვიმის წვეთებს, თოვლსა და მზის პირდაპირ სხივებს არიდებს, რაც ჩანაწერს უფრო მკაფიოს ხდის.",
          en: "The camera is already water resistant (IP67). The protector keeps raindrops, snow, and direct sunlight off the lens for clearer footage.",
        },
      },
      {
        key: { ka: "ანარეკლის გარეშე:", en: "Anti-Glare:" },
        value: {
          ka: "დამცავის შიდა მხარე მქრქალი შავია, რაც ამცირებს სინათლის ანარეკლს ლინზაზე.",
          en: "The matte black underside reduces light reflections on the lens.",
        },
      },
      {
        key: { ka: "გამძლე მასალა:", en: "Durable Material:" },
        value: {
          ka: "მსუბუქი, მაგრამ მტკიცე ABS პლასტმასი გარე პირობებში ხანგრძლივად გაძლებს.",
          en: "Lightweight yet sturdy ABS plastic built to last outdoors.",
        },
      },
      {
        key: { ka: "მარტივი მონტაჟი:", en: "Easy Installation:" },
        value: {
          ka: "დამცავი კამერაზე მზის პანელის დამაგრებამდე თავსდება და კომპლექტში შემავალი ორმხრივი ლენტით მაგრდება, ბურღვის გარეშე.",
          en: "Fit the protector on the camera before attaching the solar panel and secure it with the included double-sided tape, no drilling required.",
        },
      },
    ],
    specs: [
      {
        key: { ka: "თავსებადობა", en: "Compatibility" },
        value: {
          ka: (
            <Link className="underline" to="/eufy-SoloCam-S340">
              eufy SoloCam S340
            </Link>
          ),
          en: (
            <Link className="underline" to="/en/eufy-SoloCam-S340">
              eufy SoloCam S340
            </Link>
          ),
        },
      },
      {
        key: { ka: "მასალა", en: "Material" },
        value: { ka: "ABS პლასტმასი", en: "ABS plastic" },
      },
      {
        key: { ka: "ფერი", en: "Color" },
        value: { ka: "თეთრი", en: "White" },
      },
      {
        key: { ka: "მონტაჟი", en: "Installation" },
        value: { ka: "ორმხრივი წებოვანი ლენტი", en: "Double-sided tape" },
      },
      {
        key: { ka: "კანონისმიერი გარანტია", en: "Legal Warranty" },
        value: { ka: "2 წელი", en: "2 years" },
      },
      {
        key: { ka: "რა არის ყუთში", en: "What's in the box" },
        value: {
          ka: (
            <ul>
              <li>დამცავი</li>
              <li>ორმხრივი წებოვანი ლენტი</li>
              <li>ჭანჭიკები</li>
            </ul>
          ),
          en: (
            <ul>
              <li>Protector</li>
              <li>Double-sided tape</li>
              <li>Screws</li>
            </ul>
          ),
        },
      },
    ],
  }
];